import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import {
  API_ENDPOINTS,
  DEFAULT_PAGE_START,
  DEFAULT_PER_PAGE_RECORD,
} from '../Utils/constants'
import { getUtcUnixDate, getStartDate } from '../Utils/rules'

export default class TagStore extends FetchBase {
  @observable projectOrdering = undefined
  @observable projectOrderingBy = undefined

  @observable spaceOrdering = undefined
  @observable spaceOrderingBy = undefined

  @observable projectTagSearchText = ''
  @observable SpaceTagSearchText = ''
  @observable projectTagFilters = {}
  @observable spaceTagFilter = {}

  @observable allProjectTagPageNo = DEFAULT_PAGE_START
  @observable allSpaceTagPageNo = DEFAULT_PAGE_START

  @observable projectTagPageSize = DEFAULT_PER_PAGE_RECORD
  @observable spaceTagPageSize = DEFAULT_PER_PAGE_RECORD

  @observable spaceTagLoader = true

  @observable mergeProjectTagLoader = false
  @observable mergeSpaceTagLoader = false

  @observable spaceTagList = []
  @observable allSpaceTagsList = []
  @observable spaceTagTotal = 0

  @observable projectTagLoader = true
  @observable projectTagList = []
  @observable allProjectTagsList = []
  @observable projectTagTotal = 0

  @observable searchTextForUsersList = undefined
  @observable usersFilters = {}

  @observable orderBy = undefined

  @action.bound
  setProjectOrdering = (value = undefined) => {
    this.projectOrdering = value
  }
  @action.bound
  setSpaceOrdering = (value = undefined) => {
    this.spaceOrdering = value
  }

  @action.bound
  setProjectOrderingBy = (value = undefined) => {
    this.projectOrderingBy = value
  }
  @action.bound
  setSpaceOrderingBy = (value = undefined) => {
    this.spaceOrderingBy = value
  }

  @action.bound
  setProjectTagPageNo = (value = DEFAULT_PAGE_START) => {
    this.allProjectTagPageNo = value
  }

  @action.bound
  setSpaceTagPageNo = (value = DEFAULT_PAGE_START) => {
    this.allSpaceTagPageNo = value
  }

  @action.bound
  setProjectTagPageSize = (size = DEFAULT_PER_PAGE_RECORD) => {
    this.projectTagPageSize = size
  }

  @action.bound
  setSpaceTagPageSize = (size = DEFAULT_PER_PAGE_RECORD) => {
    this.spaceTagPageSize = size
  }

  @action.bound
  setProjectTagFilter = (values = {}) => {
    this.projectTagFilters = values
  }

  @action.bound
  setSpaceTagFilter = (values = {}) => {
    this.spaceTagFilter = values
  }

  @action.bound
  setProjectTagSearchText = (value = '') => {
    this.projectTagSearchText = value
  }

  @action.bound
  setSpaceTagSearchText = (value = '') => {
    this.SpaceTagSearchText = value
  }

  @action.bound
  generateProjectTagFilters = () => {
    let tempGenerateProjectTagFilter = {}

    let keys = Object.keys(this.projectTagFilters || {})
    for (let filter of keys) {
      if (this.projectTagFilters[filter] !== undefined) {
        tempGenerateProjectTagFilter[filter] = this.projectTagFilters[filter]
      }
    }
    this.projectTagSearchText &&
      (tempGenerateProjectTagFilter['search'] = this.projectTagSearchText)
    this.projectOrdering &&
      (tempGenerateProjectTagFilter['ordering'] = this.projectOrdering)
    this.projectOrdering &&
      (tempGenerateProjectTagFilter['orderBy'] = this.projectOrderingBy)
    return tempGenerateProjectTagFilter
  }

  @action.bound
  generateSpaceTagFilters = () => {
    let tempGenerateSpaceTagFilter = {}

    let keys = Object.keys(this.spaceTagFilter || {})
    for (let filter of keys) {
      if (this.spaceTagFilter[filter] !== undefined) {
        tempGenerateSpaceTagFilter[filter] = this.spaceTagFilter[filter]
      }
    }
    this.SpaceTagSearchText &&
      (tempGenerateSpaceTagFilter['search'] = this.SpaceTagSearchText)
    this.spaceOrdering &&
      (tempGenerateSpaceTagFilter['ordering'] = this.spaceOrdering)
    this.spaceOrdering &&
      (tempGenerateSpaceTagFilter['orderBy'] = this.spaceOrderingBy)
    return tempGenerateSpaceTagFilter
  }

  @action.bound
  projectTagExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.generateProjectTagFilters()
      options['exportFileType'] = exportFileType
      let response = await this.get(API_ENDPOINTS.EXPORT_PROJECT_TAG, {
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  spaceTagExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.generateSpaceTagFilters()
      options['exportFileType'] = exportFileType
      let response = await this.get(API_ENDPOINTS.EXPORT_SPACE_TAG, {
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  listSpaceTag = async (signal) => {
    try {
      this.spaceTagLoader = true
      let options = this.generateSpaceTagFilters() || {}
      this.searchTextForUsersList &&
        (options['search'] = this.searchTextForUsersList)
      let response = await this.get(
        API_ENDPOINTS.LIST_SPACE_TAG,
        {
          pageNo: Math.max(this.allSpaceTagPageNo - 1, 0),
          pageLimit: this.spaceTagPageSize,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.spaceTagList = response.data.spaceTags
        this.spaceTagTotal = response.data.total || 0
        return true
      }
      this.spaceTagList = []
      this.spaceTagTotal = 0

      return false
    } catch (err) {
      this.spaceTagList = []
      this.spaceTagTotal = 0

      return false
    } finally {
      this.spaceTagLoader = false
    }
  }

  @action.bound
  listAllSpaceTag = async (signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.LIST_SPACE_TAG,
        {
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        this.allSpaceTagsList = response.data.spaceTags
        return true
      }
      return false
    } catch (err) {
      this.allSpaceTagsList = []
      return false
    } finally {
    }
  }

  @action.bound
  listAllProjectTag = async (signal) => {
    try {
      this.projectTagLoader = true
      let response = await this.get(
        API_ENDPOINTS.LIST_PROJECT_TAG,
        {
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        this.allProjectTagsList = response.data.projectTags
        return true
      }
      this.allProjectTagsList = []

      return false
    } catch (err) {
      this.allProjectTagsList = []

      return false
    } finally {
    }
  }

  @action.bound
  listProjectTag = async (signal) => {
    try {
      this.projectTagLoader = true
      let options = this.generateProjectTagFilters() || {}
      this.searchTextForUsersList &&
        (options['search'] = this.searchTextForUsersList)
      let response = await this.get(
        API_ENDPOINTS.LIST_PROJECT_TAG,
        {
          pageNo: Math.max(this.allProjectTagPageNo - 1, 0),
          pageLimit: this.projectTagPageSize,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.projectTagList = response.data.projectTags
        this.projectTagTotal = response.data.total || 0
        return true
      }
      this.projectTagTotal = 0
      this.projectTagList = []

      return false
    } catch (err) {
      this.projectTagTotal = 0
      this.projectTagList = []

      return false
    } finally {
      this.projectTagLoader = false
    }
  }

  @action.bound
  deleteProjectTag = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_PROJECT_TAG, {
        id: id,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteSpaceTag = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_SPACE_TAG, {
        id: id,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }
  @action.bound
  deleteBulkSpaceTag = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS?.BULK_DELETE_SPACE_TAG, {
        ids: id,
      })
      if (response.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteBulkProjectTag = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS?.BULK_DELETE_PROJECT_TAG, {
        ids: id,
      })
      if (response.status) {
        return [true, response?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addProjectTag = async (values) => {
    try {
      this.projectTagLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_PROJECT_TAG, values)
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectTagLoader = false
    }
  }

  @action.bound
  addSpaceTag = async (values) => {
    try {
      this.spaceTagLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_SPACE_TAG, values)
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.spaceTagLoader = false
    }
  }

  @action.bound
  getMultipleProjectTagsById = async (values) => {
    try {
      this.mergeProjectTagLoader = true
      let response = await this.post(API_ENDPOINTS.GET_PROJECT_TAG_BY_IDS, {
        ids: values,
      })
      if (response.status) {
        return [response.status, response.data.projectTags]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.mergeProjectTagLoader = false
    }
  }

  @action.bound
  getMultipleSpaceTagsById = async (values) => {
    try {
      this.mergeSpaceTagLoader = true
      let response = await this.post(API_ENDPOINTS.GET_SPACE_TAG_BY_IDS, {
        ids: values,
      })
      if (response.status) {
        return [response.status, response.data.spaceTags]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.mergeSpaceTagLoader = false
    }
  }

  @action.bound
  mergeSpaceTag = async (values) => {
    try {
      this.mergeSpaceTagLoader = true
      let response = await this.post(API_ENDPOINTS.BULK_MERGE_SPACE_TAG, values)
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.mergeSpaceTagLoader = false
    }
  }

  @action.bound
  mergeProjectTag = async (values) => {
    try {
      this.mergeProjectTagLoader = true
      let response = await this.post(
        API_ENDPOINTS.BULK_MERGE_PROJECT_TAG,
        values
      )
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.mergeProjectTagLoader = false
    }
  }

  @action.bound
  updateProjectTag = async (id, values) => {
    try {
      this.projectTagLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_PROJECT_TAG, {
        id,
        ...values,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectTagLoader = false
    }
  }

  @action.bound
  updateSpaceTag = async (id, values) => {
    try {
      this.spaceTagLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_SPACE_TAG, {
        id,
        ...values,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.spaceTagLoader = false
    }
  }

  @action.bound
  checkSpaceTag = async (value) => {
    try {
      this.spaceTagLoader = true
      let response = await this.post(API_ENDPOINTS.CHECK_IF_SPACE_TAG_EXIST, {
        name: value,
      })
      if (response.status) {
        return [response.status, response?.data?.exist]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.spaceTagLoader = false
    }
  }

  @action.bound
  checkProjectTag = async (value) => {
    try {
      this.projectTagLoader = true
      let response = await this.post(API_ENDPOINTS.CHECK_IF_PROJECT_TAG_EXIST, {
        name: value,
      })
      if (response.status) {
        return [response.status, response?.data?.exist]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectTagLoader = false
    }
  }

  @action.bound
  resetFilterForm = () => {
    this.projectTagFilters = {}
    this.spaceTagFilter = {}
  }

  @action.bound
  resetUserFilters = () => {
    this.usersFilters = {}

    this.projectOrdering = undefined
    this.spaceOrdering = undefined
    this.orderBy = undefined
  }

  @action.bound
  resetStore = () => {
    this.projectTagSearchText = ''
    this.SpaceTagSearchText = ''
    this.projectTagFilters = {}
    this.spaceTagFilter = {}
    this.allSpaceTagsList = []
    this.allProjectTagsList = []
    this.spaceTagTotal = 0
    this.projectTagTotal = 0
    this.allProjectTagPageNo = DEFAULT_PAGE_START
    this.allSpaceTagPageNo = DEFAULT_PAGE_START
    this.projectTagPageSize = DEFAULT_PER_PAGE_RECORD
    this.spaceTagPageSize = DEFAULT_PER_PAGE_RECORD
    this.spaceTagLoader = true
    this.projectTagLoader = true
    this.mergeProjectTagLoader = false
    this.mergeSpaceTagLoader = false
    this.projectTagList = []

    this.selectedCustomerId = undefined
    this.searchTextForUsersList = undefined
    this.usersFilters = {}
    this.projectOrdering = undefined
    this.spaceOrdering = undefined
    this.orderBy = undefined
    this.spaceTagList = []
    this.projectLineFilterforColor = []
    this.projectOrderingBy = undefined
    this.spaceOrderingBy = undefined
  }
}
